<template>
  <cellList
    :cell-list="keywordList"
    :thumbnail-info="thumbnailInfo"
    container-class-name="cell-list responsive cell-poster"
    @cell-click-log="sendCellClickLog"
  />
</template>
<script>
import CellList from '@/components/section/template/cell/CellList'
import { sendEventLogAutoCompleteContents } from '@/common/util/log.v2.send'

export default {
  name: 'SearchAutoCompleteCellList',
  components: { CellList },
  props: {
    keywordList: {
      type: Array
    },
    thumbnailInfo: {
      type: Object
    }
  },
  computed: {
    getCellListContainerClassName () {
      return `cell-list responsive cell-${this.thumbnailInfo.type}`
    }
  },
  methods: {
    sendCellClickLog ({ cellInfo = {}, index = -1 }) {
      return sendEventLogAutoCompleteContents({ cellInfo: cellInfo, index: index })
    }
  }
}
</script>
